export default "__VITE_ASSET__BECPF_Ci__"